import React from "react";

const EnvelopeIcon = ({ className, color }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill={"none"}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g clipPath="url(#clip0_15_17)">
          {" "}
          <rect width="24" height="24" fill="white"></rect>{" "}
          <path
            d="M3 17.5V6.5C3 5.94772 3.44772 5.5 4 5.5H12H20C20.5523 5.5 21 5.94772 21 6.5V17.5C21 18.0523 20.5523 18.5 20 18.5H4C3.44772 18.5 3 18.0523 3 17.5Z"
            stroke={color || "#000000"}
            strokeLinejoin="round"
          ></path>{" "}
          <path
            d="M3 6L12 12L21 6"
            stroke={color || "#000000"}
            strokeLinejoin="round"
          ></path>{" "}
        </g>{" "}
        <defs>
          {" "}
          <clipPath id="clip0_15_17">
            {" "}
            <rect width="24" height="24" fill="white"></rect>{" "}
          </clipPath>{" "}
        </defs>{" "}
      </g>
    </svg>
  );
};

export default EnvelopeIcon;
